<template>
  <Photos year="2014" :min-date="1393891200" :max-date="1394150400" date-text="March 4&ndash;7" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
